import React, { FC } from 'react'
import PBSError from '../../../../shared/PBSError'
import { getErrorDescriptionDetails } from '../../lib/helpers'

const ErrorDescription: FC<{ e: PBSError }> = ({ e }) => {
  const { errorText, errorCodePrefix, errorDetails } =
    getErrorDescriptionDetails(e)
  return (
    <p>
      {errorText}
      <br />
      <br />
      Error: {errorCodePrefix} {errorDetails}
    </p>
  )
}

export default ErrorDescription
